(function(){
  var FREE = window.LMC_FREE_SHIP || 7900; // seuil livraison offerte en centimes (79 €)
  var cart, body, foot, empty, count, total, ship;
  function $(id){return document.getElementById(id);}

  function money(c){
    try{return (c/100).toLocaleString('fr-FR',{style:'currency',currency:window.LMC_CURRENCY||'EUR'});}
    catch(e){return (c/100).toFixed(2)+' €';}
  }

  function open(){cart.classList.add('open');cart.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function close(){cart.classList.remove('open');cart.setAttribute('aria-hidden','true');document.body.style.overflow='';}

  function render(data){
    count.textContent = data.item_count;
    // bulle du header
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], #lmcCount, .cart-count-bubble').forEach(function(el){
      if(el.id==='lmcCount'){el.textContent=data.item_count;}
    });
    var bubble=document.querySelector('.header__icon--cart .cart-count-bubble');
    if(bubble){var s=bubble.querySelector('span[aria-hidden]');if(s)s.textContent=data.item_count;}

    if(data.item_count===0){
      body.hidden=true;foot.hidden=true;empty.style.display='flex';ship.innerHTML='';return;
    }
    empty.style.display='none';body.hidden=false;foot.hidden=false;

    // barre livraison offerte
    ship.innerHTML='\u2713 Livraison offerte d\u00e9bloqu\u00e9e !';

    // items
    body.innerHTML = data.items.map(function(it){
      return '<div class="lmc-it" data-key="'+it.key+'">'+
        '<img class="lmc-it__im" src="'+(it.image? it.image.replace(/(\.[a-z]+)(\?|$)/,'_100x$1$2'):'')+'" alt="">'+
        '<div class="lmc-it__c">'+
          '<div class="lmc-it__t">'+it.product_title+'</div>'+
          (it.variant_title? '<div class="lmc-it__v">'+it.variant_title+'</div>':'')+
          '<div class="lmc-it__b">'+
            '<div class="lmc-it__q">'+
              '<button data-lmc-dec="'+it.key+'" aria-label="Moins">−</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button data-lmc-inc="'+it.key+'" aria-label="Plus">+</button>'+
            '</div>'+
            '<div class="lmc-it__p">'+money(it.final_line_price)+'</div>'+
          '</div>'+
          '<button class="lmc-it__rm" data-lmc-rm="'+it.key+'">Retirer</button>'+
        '</div>'+
      '</div>';
    }).join('');
    total.textContent = money(data.total_price);
  }

  function fetchCart(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(render);
  }

  function change(key,qty){
    return fetch('/cart/change.js',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    }).then(function(r){return r.json();}).then(render);
  }

  function addToCart(form){
    var fd=new FormData(form);
    return fetch('/cart/add.js',{method:'POST',body:fd})
      .then(function(r){return r.json();})
      .then(function(){return fetchCart();})
      .then(function(){open();});
  }

  document.addEventListener('DOMContentLoaded',function(){
    cart=$('lmcCart');if(!cart)return;
    body=$('lmcBody');foot=$('lmcFoot');empty=$('lmcEmpty');
    count=$('lmcCount');total=$('lmcTotal');ship=$('lmcShip');

    // ouvrir via l'icone panier du header
    document.querySelectorAll('.header__icon--cart, #cart-icon-bubble, a[href="/cart"], a[href$="/cart"]').forEach(function(a){
      a.addEventListener('click',function(e){e.preventDefault();open();});
    });
    // fermer
    cart.querySelectorAll('[data-lmc-close]').forEach(function(b){b.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

    // intercepter TOUS les formulaires d'ajout au panier
    document.addEventListener('submit',function(e){
      var form=e.target;
      if(form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add')>-1){
        e.preventDefault();addToCart(form);
      }
    },true);

    // quantite + suppression (delegation)
    body.addEventListener('click',function(e){
      var inc=e.target.closest('[data-lmc-inc]');
      var dec=e.target.closest('[data-lmc-dec]');
      var rm=e.target.closest('[data-lmc-rm]');
      var line=e.target.closest('.lmc-it');
      if(!line)return;
      var q=parseInt(line.querySelector('.lmc-it__q span').textContent)||1;
      if(inc)change(inc.getAttribute('data-lmc-inc'),q+1);
      else if(dec)change(dec.getAttribute('data-lmc-dec'),Math.max(0,q-1));
      else if(rm)change(rm.getAttribute('data-lmc-rm'),0);
    });

    fetchCart();
  });
})();
